import React from 'react'

export default function Digital() {
  return (
    <svg width="124" height="80" viewBox="0 0 124 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<line x1="16.3638" y1="78" x2="107.273" y2="78" stroke="black" stroke-width="4"className='digiline'/>
<rect x="2" y="2" width="119.636" height="59.6364" rx="8" stroke="black" stroke-width="4" className='digitv'/>
<rect x="12" y="2.90906" width="39.6364" height="58.7273" rx="8" stroke="black" stroke-width="4" className='digiphone'/>
</svg>

  )
}
